module.exports = __webpack_public_path__ + "img/Services-Air-CROP.140099df.png";